import styled from "@emotion/styled"
import { Tab, Tabs, tabClasses, tabsClasses } from "@mui/material"
import COLORS from "../../common/FortesColors"

export interface SwitchProps {
  value: string
  options: Array<{
    name: string
    onClick: () => void
  }>
  width: "Large" | "Medium" | "Small" | "ExtraSmall"
}

export function FortesSwitch(props: SwitchProps) {
  return <StyledTabs {...props} />
}

function StyledTabs(props: SwitchProps): JSX.Element {
  const width =
    props.width === "Large"
      ? 410
      : props.width === "ExtraSmall"
      ? 70
      : props.width === "Medium"
      ? 290
      : 150
  return (
    <Tabs
      value={props.options.findIndex((item) => item.name === props.value)}
      sx={{
        //height: 48,
        padding: "3px",
        minHeight: 30,
        minWidth: 20,
        width: `${width}px`,
        borderRadius: 60,
        zIndex: 2,
        backgroundColor: "#eef2f6",
        indicatorColor: "green",
        [`& .${tabsClasses.indicator}`]: {
          height: "100%",
          borderRadius: 20,
          backgroundColor: COLORS.darkPurple,
        },
      }}
    >
      {props.options.map((option) => (
        <StyledTab
          sx={{ width: `${width / props.options.length}px` }}
          label={option.name}
          onClick={option.onClick}
        />
      ))}
    </Tabs>
  )
}

const StyledTab = styled(Tab)(({}) => ({
  zIndex: 1,
  textTransform: "none",
  color: "#1a0549",
  minHeight: 30,
  minWidth: 30,
  height: 40,
  padding: 0,
  [`&.${tabClasses.selected}`]: {
    color: "white",
  },
}))
